import {
  MatDateFormats,
  NativeDateAdapter,
} from '@angular/material/core';
import {Injectable} from '@angular/core';
import {DatePipe} from '@angular/common';
import {Constants} from '../../../../../common/constants/constants';

@Injectable({providedIn: 'root'})
export class AppDateAdapter extends NativeDateAdapter {

  override parse(value: any): Date | null {
    const getDate = (dateValue: string): Date | null => {
      const str = dateValue.split(Constants.DOT);
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);
      return new Date(year, month, date);
    };
    if (typeof value === 'string') {
      if (value.indexOf(Constants.DOT) > -1) {
        return getDate(value);
      }
      if (value.length === 8) {
        const str = value.replace(/(\d{2})(\d{2})(\d{4})/, '$1.$2.$3');
        return getDate(str);
      }
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return Number.isNaN(timestamp) ? null : new Date(timestamp);
  }

  override format(date: Date, displayFormat: any): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? `0${day}` : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? `0${month}` : month;
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
    if (displayFormat === 'MMM-YYYY') {
      return new DatePipe(this.locale).transform(date, 'MMM yyyy');
    }
    return date.toDateString();
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }

}

export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: {month: 'short', year: 'numeric', day: 'numeric'},
  },
  display: {
    dateInput: 'input',
    monthYearLabel: 'MMM-YYYY',
    dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
    monthYearA11yLabel: {year: 'numeric', month: 'long'},
  },
};
